export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9399.3a8a3dcb.jpg";